const isInOptions = function(value, options){
    if (!options) {
        return false
    }
    else return options.some(option => value === option.value)
}

export default isInOptions